<template>
    <div class="score-section" :class="{ 'is-active': isActive }">
        <button 
            class="task-name" 
            @click="navigateToTask"
            :class="{ 'active': isActive }"
        >
            <span>{{ taskName }}</span>
        </button>
        <div class="scores">
            <button
                v-if="qaClickableStatus"
                class="qa-status-row qa-status-btn"
                @click="$emit('qa-action')"
            >
                <span v-if="commentCount > 0" class="qa-chip comments-chip">💬 {{ commentCount }}</span>
                <span v-if="openRequestCount > 0" class="qa-chip requests-chip">⚑ {{ openRequestCount }}</span>
                <span class="qa-status-label">{{ qaStatusLabel }}</span>
            </button>
            <div v-else-if="commentCount > 0 || openRequestCount > 0" class="qa-status-row">
                <span v-if="commentCount > 0" class="qa-chip comments-chip">💬 {{ commentCount }}</span>
                <span v-if="openRequestCount > 0" class="qa-chip requests-chip">⚑ {{ openRequestCount }}</span>
                <button v-if="qaActionLabel" class="qa-action-btn" @click="$emit('qa-action')">{{ qaActionLabel }}</button>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScoreSection',
    emits: ['qa-action'],
    props: {
        taskName: {
            type: String,
            required: true,
        },
        route: {
            type: String,
            required: true,
        },
        currentRoute: {
            type: String,
            default: '',
        },
        commentCount: {
            type: Number,
            default: 0,
        },
        openRequestCount: {
            type: Number,
            default: 0,
        },
        qaActionLabel: {
            type: String,
            default: '',
        },
        qaClickableStatus: {
            type: Boolean,
            default: false,
        },
        qaStatusLabel: {
            type: String,
            default: 'Comments / Requests'
        }
    },
    computed: {
        isActive() {
            return this.currentRoute === this.route;
        }
    },
    methods: {
        navigateToTask() {
            this.$router.push(this.route);
        }
    }
};
</script>

<style scoped>
.score-section {
    display: flex;
    border: 1px solid #ccc;
    margin: 10px 0;
    padding: 10px;
    border-radius: 8px;
    background-color: #f9f9f9;
    transition: margin-left 0.2s ease;
}

.score-section.is-active {
    margin-left: 20px;
    background-color: #f0f8ff;
}

.task-name {
    writing-mode: vertical-lr;
    text-orientation: mixed;
    transform: rotate(180deg);
    text-align: center;
    margin-right: 20px;
    font-weight: bold;
    background-color: #317391;
    color: white;
    padding: 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease;
}

.task-name:hover {
    background-color: #4a9bc7;
    transform: rotate(180deg) scale(1.05);
    box-shadow: 0 2px 8px rgba(49, 115, 145, 0.4);
}

.task-name.active {
    background-color: #1a5a7a;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.task-name:active {
    transform: rotate(180deg) scale(0.98);
}

.scores {
    flex: 1;
    flex-direction: column;
    display: flex;
    margin: 20px;
    font-size: 14px;
    max-width: none;
    min-width: 0;
}

.qa-status-row {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.qa-status-btn {
    width: fit-content;
    border: 1px solid #cbd5e1;
    border-radius: 9999px;
    padding: 4px 10px;
    background: #f8fafc;
    cursor: pointer;
    align-items: center;
}

.qa-status-btn:hover {
    background: #eff6ff;
    border-color: #93c5fd;
}

.qa-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 9999px;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 600;
}

.comments-chip {
    color: #1d4ed8;
    background: #dbeafe;
    border: 1px solid #93c5fd;
}

.requests-chip {
    color: #92400e;
    background: #fef3c7;
    border: 1px solid #fcd34d;
}

.qa-action-btn {
    border: 1px solid #93c5fd;
    background: #eff6ff;
    color: #1d4ed8;
    border-radius: 9999px;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
}

.qa-status-label {
    color: #334155;
    font-size: 12px;
    font-weight: 600;
}

.qa-action-btn:hover {
    background: #dbeafe;
}
</style>
  